<template>
  <div class="home-banner">
    <div class="banner-logo">
      <img class="logo-img" src="https://global-application-001.downline.cn/www.duzikai.com/goods_image/JmtbpP1700707746324.png" alt="">
      <div class="logo-text">
        <div class="letter-text">AI</div>
        <div>引擎</div>
      </div>
    </div>
    <div class="banner-text">能为企业创造生产力的</div>
    <div class="banner-btn">AI办公平台</div>
    <div class="circle-arrow" @click="goTop">
      <img class="arrow-img" src="../../assets/image/banner_arrow.png" alt="">
    </div>
    <div class="robot-bg">
      <img src="https://global-application-001.downline.cn/www.duzikai.com/goods_image/HJawEr1700707706987.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        timer: null
      }
    },
    methods: {
      goTop() {
        // cancelAnimationFrame(this.timer);
        const self = this;
        const oTop = document.body.scrollTop || document.documentElement.scrollTop;
        document.body.scrollTop = document.documentElement.scrollTop = oTop + 860;
        this.$emit('handleSendFlag', true)
        /*self.timer = requestAnimationFrame(function fn() {
          self.timer = requestAnimationFrame(fn);
          if (oTop === 0) {

            self.timer = requestAnimationFrame(fn);
          } else {
            cancelAnimationFrame(self.timer);
          }
        });*/
      },
    }
  }
</script>

<style lang="less" scoped>
  .home-banner {
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 220px;
    line-height: 1;
    position: relative;
    .banner-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 120px;
      color: #2C6CE6;
      font-weight: 600;
      font-family: "SourceHanSansCN-Heavy";
      margin-bottom: 24px;
      .logo-text {
        display: flex;
        align-items: center;
      }
      .letter-text {
        font-size: 140px;
        margin-right: 30px;
        margin-left: 20px;
      }
      .logo-img {
        width: 350px;
        height: 100%;
      }
    }
    .banner-text {
      font-size: 80px;
      color: #222222;
      font-weight: 600;
      letter-spacing: 10px;
      position: relative;
      z-index: 1;
    }
    .banner-btn {
      width: 470px;
      height: 176px;
      margin: 32px auto;
      background-image: url("../../assets/image/banner_btn_bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      line-height: 176px;
      font-size: 60px;
      font-weight: 600;
      cursor: pointer;
    }
    .circle-arrow {
      width: 80px;
      height: 80px;
      background-color: #fff;
      border-radius: 50%;
      border: 2px solid #000000;
      margin: 120px auto 90px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 9;
      .arrow-img {
        width: 26px;
        height: 34px;
      }
    }
    .robot-bg {
      position: absolute;
      right: -120px;
      top: 146px;
      width: 382px;
      height: 390px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>